import { useEffect, useState } from "react";
import { exchangeOAuthCode } from "../lib/dive";

type Status = "exchanging" | "done" | { error: string };

interface Props {
  code: string;
  state: string;
}

export function ConnectDiveView({ code, state }: Props) {
  const [status, setStatus] = useState<Status>("exchanging");

  useEffect(() => {
    exchangeOAuthCode(code, state)
      .then(() => setStatus("done"))
      .catch((err: unknown) => {
        setStatus({ error: err instanceof Error ? err.message : "Connection failed" });
      });
  // Run once on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "exchanging") {
    return (
      <div className="flex items-center justify-center h-screen font-mono text-sm text-gray-400">
        Connecting to Dive…
      </div>
    );
  }

  if (status === "done") {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-6 px-6 text-center">
        <div className="flex items-center gap-3">
          <span className="font-syne text-2xl font-bold text-gray-900">Crux</span>
          <span className="text-gray-300 text-2xl">↔</span>
          <span className="font-syne text-2xl font-bold text-gray-900">Dive</span>
        </div>
        <div>
          <h2 className="font-syne text-xl font-bold text-gray-900 mb-2">Connected</h2>
          <p className="text-sm font-mono text-gray-500">
            Dive is connected. You can close this tab.
          </p>
        </div>
        <button
          onClick={() => window.close()}
          className="bg-gray-900 text-white font-mono font-bold text-sm px-8 py-3 rounded-xl hover:bg-gray-700 transition-colors"
        >
          Close tab
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 px-6 text-center">
      <p className="text-sm font-mono text-red-500">{status.error}</p>
      <button
        onClick={() => window.history.back()}
        className="text-sm font-mono text-gray-500 hover:text-gray-700 transition-colors"
      >
        Go back
      </button>
    </div>
  );
}
